import { createApp } from 'vue';
import { initErrorTracker, loadFont, setPalette } from '@/utility';
import { initGTM } from '@/plugins';
import AppTransition from '@/components/common/AppTransition';
import { TopPositionDirective } from '@/directives';
import integrator from '@/services/integrator';
import config from '../config';
import App from './App';
import router from './router';
import store from './store';
import './polyfills';
import '@/styles/main.scss';

const app = createApp(App);

app.component('AppTransition', AppTransition);
app.directive('top-position', TopPositionDirective);

const setupApp = async () => {
  await store.dispatch('loadApplicationSettings');
  const { palette, font, GTMCode } = store.state.applicationSettings;

  if (GTMCode) initGTM(app, GTMCode);
  setPalette(palette);
  loadFont(font);
};

const startApp = async () => {
  if (config.errorTracker.active) initErrorTracker(app, router);

  await setupApp();

  if (config.integration.active) {
    const message = await integrator.init(config.integration);

    store.dispatch('setInitialAppData', message);
  } else {
    // for app to work in non integration mode
    store.dispatch('setInitialAppData');
  }

  await store.dispatch('loadInitialData');

  app.use(router).use(store).mount('#app');
};

startApp();
